export default __webpack_public_path__ + "static/media/auth-reset.5e243673.png";